export default __webpack_public_path__ + "static/media/arrowRightIconSharp.39c3548e.svg";